import { styled, Box } from "@mui/material";

export const DynamicViewportOverlayRoot = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  pointerEvents: "none",
}));
